import isJson from '~/ui/pages/Coordinate/helpers/isJson';

const normalizeMemo = (memo?: string | null): string => {
  if (!memo) {
    return '';
  }

  if (!isJson(memo)) {
    return memo;
  }

  const parsedMemo = JSON.parse(memo);

  return typeof parsedMemo === 'string' ? parsedMemo : memo;
};

export default normalizeMemo;
